import {map} from 'rxjs/operators';
import {toUiMsg$} from '@/ui';
import {spotTotalAssetsSubs$} from '@/spot-wallets/sub-users-all/sub-users-assets';
import {Assets} from '@/types';

export interface UTradingBotAssetsSpot {
  type: 'spot-trading-bots-total-assets';
  data: {
    assets: Assets;
  };
}

export function subscribeSpotTradingBotsTotalAssets() {
  spotTotalAssetsSubs$
    .pipe(map((assets) => <UTradingBotAssetsSpot>{type: 'spot-trading-bots-total-assets', data: {assets}}))
    .subscribe((msg) => toUiMsg$.next(msg));
}
